import React from 'react';
import { motion } from 'framer-motion';
import { CHOCOLATES } from '@/lib/data';
import { ProductCard } from './ProductCard';
import { BundleCard } from './BundleCard';
import { Reveal, MaskedLines } from './motion/Reveal';
import { TID } from '@/constants/testIds';

const easeOut = [0.22, 1, 0.36, 1];

export const ChocolatesSection = () => {
  const individuals = CHOCOLATES.filter((c) => c.category === 'chocolate');
  const bundles = CHOCOLATES.filter((c) => c.category === 'chocolate-bundle');

  return (
    <section
      id="chocolates"
      data-testid={TID.chocolatesSection}
      className="cw-section relative"
      style={{ backgroundColor: 'rgba(254, 247, 205, 0.35)' }}
    >
      <div className="cw-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <div>
            <Reveal>
              <div className="flex items-center gap-3 flex-wrap">
                <span className="cw-label">02 — The Chocolates</span>
                <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] font-semibold bg-[var(--cw-text)] text-[var(--cw-yellow)] rounded-full px-3 py-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--cw-yellow)]" />
                  100% Eggless
                </span>
              </div>
            </Reveal>
            <MaskedLines
              className="font-heading mt-3 text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight"
              lines={[
                <>
                  Five bars. <span className="italic font-light">Single-origin.</span>
                </>,
              ]}
            />
          </div>
          <Reveal delay={0.1}>
            <p className="md:max-w-sm text-[var(--cw-muted)] text-sm leading-relaxed">
              Bean-to-bar chocolate from small cooperatives, conched slowly.
              Five classic favourites from milk to white, including a chunky
              Fruit &amp; Nut and roasted Almond Delight. Every bar is{' '}
              <strong className="text-[var(--cw-text)]">100% eggless</strong>.
            </p>
          </Reveal>
        </div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-60px' }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } },
          }}
        >
          {individuals.map((p) => (
            <motion.div
              key={p.id}
              variants={{
                hidden: { opacity: 0, y: 30 },
                show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: easeOut } },
              }}
            >
              <ProductCard product={p} accent="yellow" />
            </motion.div>
          ))}
        </motion.div>

        <div className="mt-20">
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <span className="cw-label">Family pack &amp; hamper · 5 chocolates in the gift hamper</span>
              <div className="flex-1 h-px bg-[var(--cw-border)]" />
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="grid grid-cols-1 gap-6">
              {bundles.map((p) => (
                <BundleCard key={p.id} product={p} accent="blue" />
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
